var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { styled } from 'styled-components';
import { CardPreview } from '../../../../../../../Common/components/CardPreview';
import { CardsPreloader } from './Preloader';
var ScWrapper = styled.ul.withConfig({ displayName: "ScWrapper", componentId: "sc-1tuaiq2" })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin: 0;\n  padding: 0;\n  list-style: none;\n  display: grid;\n  gap: 24px 32px;\n  grid-template-columns: 410px 410px;\n"], ["\n  margin: 0;\n  padding: 0;\n  list-style: none;\n  display: grid;\n  gap: 24px 32px;\n  grid-template-columns: 410px 410px;\n"])));
var ScCardItem = styled.li.withConfig({ displayName: "ScCardItem", componentId: "sc-1wvbpnf" })(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n"], ["\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n"])));
var ScCard = styled.div.withConfig({ displayName: "ScCard", componentId: "sc-lj56gx" })(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  width: 100%;\n  height: 228px;\n"], ["\n  width: 100%;\n  height: 228px;\n"])));
var ScCardTitle = styled.h4.withConfig({ displayName: "ScCardTitle", componentId: "sc-1ggeaof" })(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  margin-top: 0;\n  margin-bottom: 16px;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 24px;\n"], ["\n  margin-top: 0;\n  margin-bottom: 16px;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 24px;\n"])));
var CardsPreview = function (_a) {
    var cards = _a.cards, opened = _a.opened, loading = _a.loading, onCardClick = _a.onCardClick, props = __rest(_a, ["cards", "opened", "loading", "onCardClick"]);
    if (!opened)
        return null;
    if (loading)
        return _jsx(CardsPreloader, {}, void 0);
    return (_jsx(ScWrapper, __assign({}, props, { children: cards.map(function (el) { return (_jsxs(ScCardItem, { children: [_jsx(ScCardTitle, { children: el.name }, void 0), _jsx(ScCard, { children: _jsx(CardPreview, { previewImageSrc: el.data.previewUrl, cardUrl: el.data.url, target: '_blank', onClick: function () { return onCardClick === null || onCardClick === void 0 ? void 0 : onCardClick(el); } }, void 0) }, void 0)] }, el.id)); }) }), void 0));
};
export { CardsPreview };
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
